module.exports = __webpack_public_path__ + "media/old_images/intro-android-norrkoping-dae5a627.png";